import { commentTypeLabel, metadataLabel } from './moderationLabels'

const BODY_KEYS = new Set(['body', 'body_preview'])

function formatMetadataValue(key, value) {
  if (key === 'comment_type') return commentTypeLabel(value)
  return value
}

export function formatModerationMetadata(metadata) {
  if (!metadata || Object.keys(metadata).length === 0) return '—'

  const shortParts = []
  const bodyParts = []

  for (const [key, value] of Object.entries(metadata)) {
    if (value == null || value === '') continue

    const label = metadataLabel(key)
    const formattedValue = formatMetadataValue(key, value)
    const line = `${label}: ${formattedValue}`

    if (BODY_KEYS.has(key)) {
      bodyParts.push(line)
    } else {
      shortParts.push(line)
    }
  }

  if (shortParts.length === 0 && bodyParts.length === 0) return '—'

  return [...shortParts, ...bodyParts].join('\n')
}
